var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BANNER = function (level) {
    if (level === void 0) { level = "debug"; }
    return [
        "%c[@bugpilot/widget]%c [".concat(new Date().toISOString(), "] %c[").concat(level.toUpperCase(), "]"),
        "color:white; font-weight: bold; border-radius: 5px; padding:2px 5px; background:lightpurple;",
        "color:#999;",
        "color:#6060ff;",
    ];
};
var logger = {
    info: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.log.apply(console, __spreadArray(__spreadArray([], BANNER("info"), false), args, false));
    },
    warn: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.warn.apply(console, __spreadArray(__spreadArray([], BANNER("warn"), false), args, false));
    },
    error: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.error.apply(console, __spreadArray(__spreadArray([], BANNER("error"), false), args, false));
    },
    debug: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.debug.apply(console, __spreadArray(__spreadArray([], BANNER("debug"), false), args, false));
    },
};
export default logger;
